import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import PndRestApi from "src/utils/pnd/PndRestApi";
import MerchantAddOrUpdate from "./MerchantAddOrUpdate";
import { Modal, ModalBody } from "reactstrap";
import { reduxForm } from 'redux-form';
import { showNotification, successNofication } from "src/shared/components/Notification";
import { Redirect } from 'react-router-dom';
import { ERROR_MESSAGES, PAGE_TIMEOUT } from "src/utils/pnd/PndConstants";
import CloseIcon from '@mui/icons-material/Close';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { CircularProgress } from '@mui/material';

const MerchantModal = ({ modalShow, setModalShow, isTitle, dataInfo }) => {
    const [isMapData, setMapData] = useState(null);
    const [isLatitude, setLatitude] = useState(null);
    const [isLongitude, setLongitide] = useState(null);
    const [isGrl, setGrl] = useState(null);
    const [isRedirect, setIsRedirect] = useState(false);
    const [loading, setLoading] = useState(false);

    if (isRedirect) {
        window.location.reload();
        return <Redirect to="/web_app/pnd_order/merchant/view" />;
    }

    const toggle = () => {
        if (!loading) {
            setModalShow(prevState => !prevState);
        }
    }

    const handleSubmit = async (formValues) => {
        try {
            setLoading(true);
            if (isMapData != null) {
                formValues["merchantAddress"] = isMapData;
            } else {
                formValues["merchantAddress"] = dataInfo?.merchantAddress;
            }
            if (formValues["merchantAddress"] === null) {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: 500`,
                    `Message:Please select address information first`,
                );
                setLoading(false);
                return;
            }
            formValues["merchantGrl"] = isGrl;
            formValues["longitude"] = isLongitude || formValues["longitude"];
            formValues["latitude"] = isLatitude || formValues["latitude"];
            if (formValues["merchantStatusInfo"]) {
                formValues["merchantStatusInfo"] = {
                    merchantStatusId: 1
                };
            } else {
                formValues["merchantStatusInfo"] = {
                    merchantStatusId: 2
                };
            }
            const response = await PndRestApi.AddOrUpdateMerchantDetails(formValues);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    ERROR_MESSAGES.successMessage,
                );
                setTimeout(() => {
                    setIsRedirect(true);
                }, PAGE_TIMEOUT);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
            }
        } catch (error) {
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Modal
                isOpen={modalShow}
                toggle={toggle}
                modalClassName="ltr-support"
                className="theme-light ltr-support"
                size="lg"
                backdrop={loading ? "static" : true}
                style={{ maxWidth: '900px' }}
            >
                {/* Modern Modal Header */}
                <div
                    className="position-relative"
                    style={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        padding: '1.5rem 2rem',
                        borderRadius: '0.5rem 0.5rem 0 0',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                    }}
                >
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <div
                                className="d-flex align-items-center justify-content-center me-3"
                                style={{
                                    width: '48px',
                                    height: '48px',
                                    background: 'rgba(255,255,255,0.2)',
                                    borderRadius: '12px',
                                    backdropFilter: 'blur(10px)'
                                }}
                            >
                                <StorefrontIcon style={{ fontSize: '28px', color: '#fff' }} />
                            </div>
                            <div>
                                <h4
                                    className="m-0 text-white fw-bold"
                                    style={{
                                        fontSize: '1.5rem',
                                        letterSpacing: '0.5px',
                                        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}
                                >
                                    {isTitle}
                                </h4>
                                <p className="m-0 text-white-50 small">
                                    {dataInfo ? 'Update merchant information' : 'Add new merchant to the system'}
                                </p>
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={toggle}
                            disabled={loading}
                            className="btn-close-custom"
                            style={{
                                background: 'rgba(255,255,255,0.2)',
                                border: 'none',
                                borderRadius: '50%',
                                width: '36px',
                                height: '36px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: loading ? 'not-allowed' : 'pointer',
                                transition: 'all 0.3s ease',
                                opacity: loading ? 0.5 : 1
                            }}
                            onMouseEnter={(e) => {
                                if (!loading) {
                                    e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
                                    e.currentTarget.style.transform = 'rotate(90deg)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                                e.currentTarget.style.transform = 'rotate(0deg)';
                            }}
                        >
                            <CloseIcon style={{ color: '#fff', fontSize: '20px' }} />
                        </button>
                    </div>
                </div>

                {/* Modal Body */}
                <ModalBody className="p-0" style={{ background: '#f8f9fa' }}>
                    {loading && (
                        <div
                            className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
                            style={{
                                background: 'rgba(255,255,255,0.9)',
                                zIndex: 1050,
                                backdropFilter: 'blur(4px)'
                            }}
                        >
                            <div className="text-center">
                                <CircularProgress size={50} style={{ color: '#667eea' }} />
                                <p className="mt-3 text-muted fw-bold">Processing...</p>
                            </div>
                        </div>
                    )}

                    <div style={{ maxHeight: 'calc(90vh - 120px)', overflowY: 'auto' }}>
                        {dataInfo ? (
                            <MerchantAddOrUpdate
                                onSubmit={handleSubmit}
                                dataInfo={dataInfo}
                                setMapData={setMapData}
                                address={dataInfo?.merchantAddress}
                                setLatitude={setLatitude}
                                setLongitide={setLongitide}
                                status={dataInfo?.merchantStatus == 1 ? true : false}
                                hubId={dataInfo?.hubId}
                                setGrl={setGrl}
                            />
                        ) : (
                            <MerchantAddOrUpdate
                                onSubmit={handleSubmit}
                                setMapData={setMapData}
                                setLatitude={setLatitude}
                                setLongitide={setLongitide}
                                setGrl={setGrl}
                            />
                        )}
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};

MerchantModal.propTypes = {
    MerchantModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state, data) => {
    if (data && data?.dataInfo) {
        return {
            initialValues: {
                merchantId: data?.dataInfo?.merchantId,
                merchantName: data?.dataInfo?.merchantName,
                merchantCode: data?.dataInfo?.merchantCode,
                merchantContactMobileNo: data?.dataInfo?.merchantContactMobileNo,
                merchantBranch: data?.dataInfo?.merchantBranch,
                merchantGrl: data?.dataInfo?.merchantGrl,
                merchantAddress: data?.dataInfo?.merchantAddress,
                merchantTelPhone: data?.dataInfo?.merchantTelPhone,
                merchantContactName: data?.dataInfo?.merchantContactName,
            }
        }
    }
}

export default connect(mapStateToProps)(reduxForm({ form: 'MerchantAddOrUpdateForm', enableReinitialize: true })(MerchantModal));